module.exports = {"150222102":"金山镇","150222103":"西斗铺镇","150222104":"下湿壕镇","150222105":"银号镇","150222106":"怀朔镇","150222107":"兴顺西镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150222.json
// module id = 497
// module chunks = 0